const locale: Locale = {
  ko: {
    acceptAll: '전체 약관 동의',
  },
  en: {
    acceptAll: 'Accept All',
  },
}

export default locale
